export class OrderFilter {
  take: number;
  currentPage: number;
  filterBy: string;
  filterString: string;
  allowPartiallyFill: boolean;
  orderActions: number;
  orderTypes: number;
  orderStatuses: number | number[];
  transactionDateFrom: string;
  transactionDateTo: string;
  orderBy: string;
  isOrderByDesc: boolean;
  orderContractStatus: number;

  constructor() {
    this.currentPage = 1;
    this.take = 12;
    this.filterBy = 'Name';
  }
}
